import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';
import { TextInput, TextArea } from 'src/components/inputs';
import ConfirmModal from '../../../../components/modal/confirm';
import modalActions from '../../../../components/modal/actions';
import reviewActions from '../../actions';
import { isValidEmail } from '../../../account/helpers';
import { productReviewReported, storeReviewReported } from '../../tracking';

class ReportReviewModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return { errors: {}, message: '', email: '' };
  }

  sendReport(data) {
    const reviewId = data ? data.review : null;
    const errors = {
      message: typeof data.message !== 'string' || !data.message.trim().length,
      email: typeof data.email !== 'string' || !isValidEmail(data.email),
    };
    if (errors.message || errors.email) {
      this.setState({ errors });
    } else {
      if (this.props.type === 'product') {
        productReviewReported();
      }
      if (this.props.type === 'store') {
        storeReviewReported();
      }

      this.props.reportReview(reviewId, data.message, data.email);
      this.close();
    }
  }

  close() {
    this.props.onComplete();
    this.setState(this.getInitialState());
  }

  render() {
    const { t } = this.context;
    const { errors } = this.state;
    const { account } = this.props;
    const email = account && account.me ? account.me.email : false;

    return (
      <ConfirmModal
        isOpen={!!this.props.review}
        showCancel
        confirmLabel={t('feedback', 'report-review.send-button')}
        title={t('feedback', 'report-review.title')}
        onCancel={() => this.close()}
        onConfirm={() => {
          this.sendReport({
            review: this.props.review,
            message: this.state.message,
            email: email !== false ? email : this.state.email,
          });
        }}
      >
        <TextArea
          onChange={e => this.setState({ message: e.target.value })}
          name="message"
          label={t('feedback', 'report-review.message-label')}
          tabIndex="0"
          warning={!!errors.message}
          helper={
            !errors.message
              ? t('feedback', 'report-review.message-helper')
              : t('feedback', 'error.field-is-required')
          }
        />
        {!email && (
          <TextInput
            onChange={e => this.setState({ email: e.target.value })}
            name="email"
            label={t('feedback', 'report-review.email-label')}
            type="email"
            tabIndex="0"
            warning={!!errors.email}
            helper={
              errors.email
                ? t('feedback', 'error.field-is-required')
                : t('feedback', 'report-review.email-helper')
            }
          />
        )}
      </ConfirmModal>
    );
  }
}

ReportReviewModal.propTypes = {
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  reportReview: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  account: PropTypes.shape({ me: PropTypes.object }),
  review: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.oneOf(['product', 'store']).isRequired,
};

ReportReviewModal.defaultProps = {
  account: { me: undefined },
  review: undefined,
};

ReportReviewModal.contextType = AppContext;

export default connect(state => ({ account: state.areas.account }), {
  ...modalActions,
  ...reviewActions,
})(ReportReviewModal);
